import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"logo-cinema4d"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M15.9687 3.86839C16.1806 3.31016 15.9783 2.82893 15.4292 2.61719C18.393 3.67152 20.188 5.7763 21.168 8.05772C21.1791 8.08171 21.1896 8.10651 21.1997 8.1321C21.1892 8.10729 21.1787 8.08249 21.168 8.05772C20.8921 7.45923 20.3018 7.36069 19.7739 7.80486C19.3211 8.19947 19.0514 8.7192 18.9358 9.28706C18.7431 10.2399 18.5697 11.1927 18.4252 12.1552C18.2451 13.3512 17.9422 14.4982 17.4681 15.575C14.725 17.3971 10.9023 16.646 9.08014 13.9029C7.258 11.1598 8.04743 7.64428 10.7906 5.82214C11.1496 5.72731 11.5142 5.64444 11.8841 5.57195C12.8956 5.37946 13.8975 5.11959 14.8897 4.8501C15.4003 4.71536 15.776 4.38812 15.9687 3.86839Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M10.7904 5.82214C11.1495 5.72731 11.5141 5.64444 11.8839 5.57195C12.8955 5.37946 13.8973 5.11959 14.8896 4.8501C15.4002 4.71536 15.7759 4.38812 15.9685 3.86839C16.1805 3.31016 15.9782 2.82893 15.4291 2.61719C18.3929 3.67152 20.1879 5.7763 21.1679 8.05772M10.7904 5.82214C9.19496 6.24352 7.71045 6.90076 6.37358 7.92998C3.64035 9.71576 1.49997 12.9997 3.64034 17.4997C4.8638 19.3668 6.86938 20.7555 8.99997 20.9997C11.6877 21.3076 14.6777 19.7875 16.2961 17.6027C16.7701 16.9612 17.1561 16.2832 17.468 15.575M10.7904 5.82214C8.04731 7.64428 7.25787 11.1598 9.08001 13.9029C10.9022 16.646 14.7248 17.3971 17.468 15.575M17.468 15.575C17.9421 14.4982 18.2449 13.3512 18.4251 12.1552C18.5696 11.1927 18.743 10.2399 18.9357 9.28706C19.0513 8.7192 19.321 8.19947 19.7738 7.80486C20.3017 7.36069 20.892 7.45923 21.1679 8.05772M21.1679 8.05772C21.179 8.08171 21.1895 8.10651 21.1995 8.1321C21.1891 8.10729 21.1785 8.08249 21.1679 8.05772ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z","strokeWidth":"props.strokeWidth"}}]}]};

const LogoCinema4D = Vue.extend<IconProps>({
  name: 'LogoCinema4DIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'logo-cinema4d',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LogoCinema4D;
